import React from 'react'
import { Link} from 'react-router-dom'
import { useAuthContext } from '../../hooks/useAuthContext'



// styles
import './aviso.css'

export default function Negocios() {
    const { user, dispatch} = useAuthContext()

  return (
    <div>
        <h1>AVISO DE  PRIVACIDAD</h1>
        <h2>
        “Rapdis” bajo la sociedad DENE SA DE CV, es el responsable del tratamiento de los datos personales que nos proporcione, los cuales serán protegidos conforme a lo dispuesto por la Ley General de Protección de Datos Personales en posesión de Sujetos Obligados, y demás normatividad que resulte aplicable.
DENE será responsable de los datos personales que recabe a través de la plataforma digital denominada comercialmente “Rapdis”, los cuales serán utilizados para fines publicitarios dentro de la aplicación móvil.
        </h2>
    </div>
  )
}
